<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Banco de Horas</h5>
                <hr>
                <TabView>
                    <TabPanel header="Saldo" class="p-mt-3">
						<SaldoBancoHoras/>
                    </TabPanel>
					<TabPanel header="Redefinir Saldo" class="p-mt-3">
						<ZerarSaldoBancoHoras ref="zerar"/>
                    </TabPanel>
                </TabView>
			</div>
		</div>
    </div>
</template>

<script>
import SaldoBancoHoras from '@/components/pages/movimento/saldoBancoHoras/SaldoBancoHoras.vue';
import ZerarSaldoBancoHoras from '@/components/pages/movimento/saldoBancoHoras/ZerarSaldoBancoHoras.vue';

export default {
	methods: {		
	},	
	components: {
		'ZerarSaldoBancoHoras': ZerarSaldoBancoHoras,
		'SaldoBancoHoras': SaldoBancoHoras,
    }
}
</script>

<style>

</style>